import React from "react";
import { GetVillasByKey } from "../api";
import Link from "next/link";
import { useTranslation } from "../../context/TranslationContext";
import KiralaGelBanner from "../KiralaGelBanner";
import useWindowSize from "../windowDimension";
import ListVilla from "../ListVilla";

const Products = ({ HomeContent, all, deviceType }) => {
  const { allRentalVillas } = useTranslation();
  const { width } = useWindowSize();

  return (
    <>
      {HomeContent &&
        HomeContent.map((item, key) => {
          return (
            <React.Fragment key={item.id}>
              <ListVilla
                title={item.title}
                description={item.kisa_icerik}
                baslik={item.baslik}
                showall={item.url}
                fetch={GetVillasByKey(item.key)}
                IconUrl={
                  item.key == "BookableDirectly" ? "/icons/kt-logo.svg" : ""
                }
              />
              {key == 1 && (
                <div className="container">
                  <KiralaGelBanner
                    src={
                      width && width > 640
                        ? "/images/kiralagel-banner/1350x210.jpeg"
                        : "/images/kiralagel-banner/575x260.png"
                    }
                    heightClass={width && width > 640 ? "h-52" : "h-60"}
                    deviceType={deviceType}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      <div className="text-center">
        <Link href={all.url}>
          <a
            title={all.title}
            className="bg-brand-blue-2 font-bold text-sm text-white py-5 px-8 inline-block mb-4 mx-auto lg:hidden "
          >
            {allRentalVillas}
          </a>
        </Link>
      </div>
    </>
  );
};

export default Products;
